<template>
    <div>
        <mt-popup class="popup" v-model="popupVisible" popup-transition="popup-fade" closeOnClickModal="true"
                  position="bottom">
            <mt-picker :slots="slots" @change="slotValueChange" showToolbar ref="picker">
                <div class="picker-toolbar-title">
                    <div class="usi-btn-cancel" @click="popCancel">取消</div>
                    <div class="">请选择</div>
                    <div class="usi-btn-sure" @click="slotValueAdd">确定</div>
                </div>
            </mt-picker>
        </mt-popup>
    </div>
</template>

<script>
    export default {
        name: "DialogShow",
        data(){
            return{
                popupVisible:false,
                slots:[{
                    values:[],
                }],
                slotSure:""
            }
        },
        props:['values'],
        methods:{
            popCancel(){
              this.popupVisible = false;
              this.slots[0].values=[]
            },
            slotValueChange(picker, values) {
                // console.log(picker,"in2")
                this.slotSure = values[0];
            },
            slotValueAdd() {
                this.popupVisible = !this.popupVisible
                this.$emit('valueCheck',parseInt( this.slotSure));
            }
        },
        watch:{
            values: function(a){
                this.popupVisible = true
                this.slots[0].values = a
            },
            popupVisible:function(){
                let values = [this.slots[0].values[0]]
                this.$refs.picker.setValues(values)
            },
            deep:true
        },
        mounted(){
            this.slots[0].values = []
        }
    }
</script>

<style scoped lang="scss">
    .popup {
        width: 100%;
    }
    .picker-toolbar-title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }
    .usi-btn-cancel,
    .usi-btn-sure {
        color: #2c9a58;
    }
</style>